import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';
import moment from 'moment';
import Modal from '@roo/roo/Modal';

import * as API from '../api';
import pageJump from '../utils/pageJump';

interface LooseObject {
    [key: string]: any;
}

/**
 * 费率 2.0 换签提醒弹窗
 * PRD：https://km.sankuai.com/page/421306591
 * 接口：https://yapi.sankuai.com/project/6079/interface/api/338212
 *
 * 弹框场景
 * - 换签开始弹窗：只弹1次（门店维度）
 */
const freeChangeRemind = () => {
    const CACHE_KEY = 'FEE_CHANGE_REMIND';
    const cacheInfoStr = getStorage(CACHE_KEY) || '{}';
    let cacheInfo: LooseObject = {};
    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }
    const wmPoiId = Ids.getWmPoiId();

    if (wmPoiId && wmPoiId !== '-1') {
        /**
         * {
         *    changeStatus: 是否已换签，0标识未换签，1标识已换签
         *    forceChangeFlag: 是否为强制换签，1标识强换完成，2表示正常换签完成
         *    startRemindShowDate: 换签开始提醒弹框的最后展示日期
         *    forceRemindShowDate: 强制换签提醒弹框的最后展示日期
         *    forceFinishShowDataList: 强制换签完成提醒的展示日期列表
         * }
         */
        const poiInfo = cacheInfo[wmPoiId] || {};

        if (!poiInfo.startRemindShowDate && poiInfo.changeStatus !== 1) {
            // 未展示过换签开始引导且处于未换签状态
            API.getChangeRemindInfo().then(res => {
                if (res.changeStatus === 1) {
                    poiInfo.changeStatus = 1;
                    cacheInfo[wmPoiId] = poiInfo;
                    setStorage(CACHE_KEY, JSON.stringify(cacheInfo));
                } else if (res.changeStage === 1) {
                    Modal.confirm({
                        title: res.title,
                        children: res.content,
                        confirmText: '精细化计费切换',
                        cancelText: '取消',
                        onConfirm: () => {
                            pageJump.go('/new_fe/business#/shop/manage/ratePlanExplanation');
                        },
                    });
                    poiInfo.startRemindShowDate = moment().format('YYYYMMDD');
                    cacheInfo[wmPoiId] = poiInfo;
                    setStorage(CACHE_KEY, JSON.stringify(cacheInfo));
                }
            });
        }
    }
};

export default freeChangeRemind;
